import { triggerDownloadWithAnchorTag } from '@asset-metrix/portal-ui';

import { getContentDispositionFileName } from '../../utils/contentDisposition';
import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const downloadTableStaticFile = async (
  contentId: string,
  defaultFileName = 'download'
): Promise<void> => {
  const response =
    await portalGatewayClient.table.downloadTableStaticFile(contentId);

  if (!response.ok) {
    let error = response.error;
    try {
      error = await response.json();
    } catch {
      // ignore
    }

    throw new HttpError(
      extractErrorMessage(error, 'Error downloading static file.'),
      response
    );
  }

  const contentDisposition = response.headers.get('content-disposition');

  const fileName =
    (contentDisposition && getContentDispositionFileName(contentDisposition)) ??
    defaultFileName;

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  triggerDownloadWithAnchorTag(blobUrl, fileName);
};
